import listComponent from '@/util/proto/listComponent'
import Item from './item'
import View from './view'

import { createDict } from '@/util/dicts'
import { getStaticPath } from '@/util/request'
import global from '@/util/mixin/global'

const stateIcon = [
  { value: 0, label: 'error' },
  { value: 1, label: 'warning' },
  { value: 2, label: 'processing' },
  { value: 3, label: 'success' },
]

export default {
  extends: listComponent,
  mixins:[global],
  data() {
    return {
      columns: [
        
        {
          title: '供应商名称',
          key: 'supplierName',
          minWidth:150,
        },
        {
          title: '联系人',
          key: 'contacts',
          minWidth:100,
        },
        {
          title: '联系电话',
          key: 'contactsPhone',
          minWidth:150,
        },
        {
          title: '备注',
          key: 'remark',
          minWidth:100,
        },
        {
          title: '操作',
          key: 'action',
          width: 200,
          fixed: "right",
          align: 'center',
          render: (h, {row}) => {

            let acts = [
              <a v-permission="ass.supplier.query" on-click={()=>this.view(row)}>查看</a>,

              <a v-permission="ass.supplier.update" on-click={()=>this.edit(row)}>编辑</a>,
              //状态：0： 有效，1：无效
              // <a on-click={()=>this.toggle(row)}>{row.state == 1 ? '启用' : '禁用'}</a>,

              <a v-permission="ass.supplier.delete" on-click={()=>this.remove(row)}>删除</a>,

            ]

            return this.$utils.link(acts, <Divider type="vertical" />)
          }
        }
      ],
      data: [],

      params: {
        supplierName:null,
      },

      loading: false,
    }
  },
  watch: {
    $route(to, from) {
      this.search()
    }
  },
  created() {
    this.def = { ...this.params }
    this.search()
  },

  methods: {
    search() {
      let params = { search: this.params.supplierName, pageSize: this.page.pageSize, pageNum: this.page.pageNum }
      this.loading = true
      this.$request.assSuppliers(params).then(resp => {
        this.loading = false
        if (!resp.code) {
          this.data = this.$utils.conv(resp.data.list || [], {  })
          this.page.total = resp.data.total || 0
        }
      })
    },

    edit( row ) {
      this.visible = true
      this.$refs['item'].init(row.id)
    },

    create() {
      this.visible = true
      this.$refs['item'].init(0)
    },

    //查看
    view(row) {
      this.$refs['itemView'].init(row.id)
    },

    remove( row ) {
      this.$ui.confirm(this.$request.assSupplierDelete, `确定删除 ${row.supplierName} ？`)(row.id).then(resp => {
        if (resp.code == 0) {
          this.$Message.success('删除成功')
          this.search()
        } else {
          this.$Message.error(resp.msg)
        }
      })
    },

   
    reset() {
      this.params = {}
      this.search()
    },

  },
  render(){

    return (
      <sl-page>
          <div class="page-filter">
          <sl-search on-search={this.search} on-reset={this.reset}>
            <sl-search-item label="">
              <i-input v-model={this.params.supplierName} placeholder="供应商名称" />
            </sl-search-item>
            <template slot="action">
              <Button v-permission="ass.supplier.insert" type="primary" icon="md-add" on-click={this.create}>新增</Button>
            </template>
          </sl-search>
        </div>
        <div class="pg-bd">
          <sl-table showHeader={true} loading={this.loading} page={this.page} columns={this.columns} data={this.data} on-change={this.$tableChange}>
          </sl-table>
        </div>
        <Item ref="item" on-update={this.search} />
        <View ref="itemView" />
      </sl-page>
    )
  }
}